import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetProfileMappingsDefaults = () => {
  const [loading, setLoading] = useState(false);
  const [mappingDefauls, setMappingDefauls] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const getMappingDefauls = profileGuid => {
    setLoading(true);

    axiosClient
      .get(`SettingProduct/CoddingProfile/CoddingMappingUpdate`, {
        params: { profileGuid },
      })
      .then(res => {
        if (res.status === 200) {
          setMappingDefauls(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getMappingDefauls, loading, mappingDefauls];
};

export default useGetProfileMappingsDefaults;
